import React, { useState } from 'react';
import TalentApplicationCard from '../TalentApplicationCard/TalentApplicationCard';
import useFetchTalentsApplication from '../../../../../../hooks/useFetchTalentsApplication';
import './talentApplicationView.css'
import Loading from '../../../../Loading/Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faInbox } from '@fortawesome/pro-solid-svg-icons';
import { checkIcon } from '../../../../../../utils/icons';

const TalentApplicationView = () => {
    const [flashMessage, setFlashMessage] = useState('')
    const { talents, loading, error, triggerFetchTalentsApplications } = useFetchTalentsApplication();
    
    const handleDeleteSuccess = () => {
        triggerFetchTalentsApplications()
        displayFlashMessage('Rechazaste un talento')
    };

    const handleAcceptSuccess = () => {
        triggerFetchTalentsApplications()
        displayFlashMessage('Agregaste un nuevo talento a tu pool')
    };

    const handleError = (errorMessage) => {
        displayFlashMessage(errorMessage)
    };

    const displayFlashMessage = (message) => {
        setFlashMessage(message);
        setTimeout(() => {
          setFlashMessage(null);
        }, 3000); 
    };

    if (loading) return <><Loading/></>;

    return (
        <>
            {flashMessage && (
                <div className="flash-message">
                    <p id="flash-message-text">{flashMessage}</p>
                    {checkIcon}
                </div>
            )}

            <div className="talent-application-view__container">
                <h1>Solicitud de talentos</h1>
                
                {error && (
                    <div className="error-message">
                        <p>Error: {error}</p>
                    </div>
                )}
                
                {Array.isArray(talents) && talents.length > 0 ? (
                    talents.map(talent => (
                        <TalentApplicationCard
                            key={talent.id}
                            data={{
                                id: talent.id,
                                name: talent.employee.name,
                                position: talent.employee.position,
                                available: talent.employee.available,
                                schedule: talent.employee.schedule,
                                employeeId: talent.employeeId,
                                profileImageUrl: talent.employee.profileImageUrl,
                            }}
                            onDeleteSuccess={handleDeleteSuccess}
                            onAcceptSuccess={handleAcceptSuccess}
                            onError={handleError}
                        />
                    ))
                ) : (
                    !error && (
                        <div className="talent-application-view__empty-state">
                            <div className="empty-state__icon">
                                <FontAwesomeIcon icon={faInbox} />
                            </div>
                            <h2 className="empty-state__title">No hay aplicaciones de talentos</h2>
                            <p className="empty-state__description">
                                Cuando los empleados envíen su CV a tu empresa, aparecerán aquí para que puedas revisarlos.
                            </p>
                            <div className="empty-state__info">
                                <div className="info-item">
                                    <FontAwesomeIcon icon={faUsers} />
                                    <span>Los empleados se postulan desde la página de empresas</span>
                                </div>
                            </div>
                        </div>
                    )
                )}
            </div>
        </>
        
    );
};

export default TalentApplicationView;

